import { call, takeEvery } from 'redux-saga/es/effects';
import * as actionTypes from './actionTypes';
import axios from 'axios/index';

const actOnInterface = (interfaceId, value) => new Promise((resolve, reject) => {
    axios.post(
        '/interfaces/' + interfaceId + '/actuate',
        { value }
    ).then(
        response => resolve(response.data),
        error => reject(error)
    );
});

function* actuateOnInterface({ interfaceId, value }) {
    const valueToPublish = isNaN(parseFloat(value)) ? value : parseFloat(value);
    yield call(actOnInterface, interfaceId, valueToPublish)
}

const controllerSagas = [
    takeEvery(actionTypes.CONTROLLER_WIDGET_ACTUATE_ON_INTERFACE, actuateOnInterface)
];

export {
    controllerSagas
};